module.exports = __webpack_public_path__ + "static/media/urbangoo23.9644367f.webp";